module.exports = __webpack_public_path__ + "static/img/BOSTON_PAINT.a5b151a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/BOSTON_PAINT.jpg
// module id = tFDV
// module chunks = 0